<template>
  <div>
    <asc-fault-monitor-item-header :item="item"></asc-fault-monitor-item-header>

    <asc-fault-monitor-detail-item
      v-for="(detailItem, index) in item.values"
      :key="index"
      :item="detailItem"
    ></asc-fault-monitor-detail-item>
  </div>
</template>

<script>
import AscFaultMonitorItemHeader from './AscFaultMonitorItemHeader'
import AscFaultMonitorDetailItem from './AscFaultMonitorDetailItem'

export default {
  name: 'AscFaultMonitorItem',

  components: {
    AscFaultMonitorItemHeader,
    AscFaultMonitorDetailItem,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>
